<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { Alert, Toggle, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { INCLUSION_HIDE_AP_DISABLE, INCLUSION_HIDE_BLUETOOTH_SETTINGS } from 'src/constants';
	import { needsPostInclusionBleDisableRpc } from 'src/helpers/ble_devices_helpers';
	//Types
	import type { DeviceInfoG2 } from 'src/types/DeviceInfoG2';
	import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';
	import NetworkConnectedStatus from '../DevicesSettings/NetworkComponents/NetworkConnectedStatus.svelte';

	export let deviceInfo: DeviceInfoG2;
	export let status: DeviceStatusG2;
	export let disableAP = false;
	export let disableBluetooth = false;

	const hasAp = !INCLUSION_HIDE_AP_DISABLE.includes(deviceInfo.model);
	const hasBluetooth = !INCLUSION_HIDE_BLUETOOTH_SETTINGS.includes(deviceInfo.model);
	const hasSecureProvisioning = !!deviceInfo.provision;
	// Wall Display fw < 2.7.1 must disable BT via RPC after inclusion (FE-2305)
	const forceWdBleDisable = needsPostInclusionBleDisableRpc(deviceInfo);
	if (forceWdBleDisable) {
		disableBluetooth = true;
	}
</script>

<Alert
	type="success"
	class="mb-s"
	heading={$format('ble_inclusion_connection_successful', {
		default: 'Connection to the device via WiFi is successful',
	})}
/>
<NetworkConnectedStatus connected={true} ip={status.wifi.sta_ip} ssid={status.wifi.ssid} />
{#if hasAp || hasBluetooth}
	<div class="d-inline-flex flex-direction-column">
		{#if hasSecureProvisioning}
			<Alert
				class="mb-s"
				type="info"
				isHeadingBold
				heading={$format('provision_security_info_title', {
					default: 'Security Measures',
				})}
				message={$format('provision_security_info', {
					default:
						'Due to strengthening security measures the Bluetooth and Access Point features will be disabled after inclusion. You can re-enable them in the device settings.',
				})}
			/>
		{/if}
		{#if hasBluetooth}
			{#if hasSecureProvisioning || forceWdBleDisable}
				<div class="mb-xs">
					<Toggle id="toggle-disable-bluetooth" size="m" checked={true} disabled={true}>
						{$format('disable_bluetooth_desc', {
							default: 'Disable Bluetooth',
						})}
					</Toggle>
					{#if hasSecureProvisioning && !forceWdBleDisable}
						<Text styleType="tiny" class="color-muted ml-xl pl-xs">
							{$format('provision_bluetooth_auto_disable_info', {
								default: 'RPC over Bluetooth is automatically disabled after inclusion.',
							})}
						</Text>
					{/if}
				</div>
			{:else}
				<Toggle id="toggle-disable-bluetooth" size="m" bind:checked={disableBluetooth}>
					{$format('disable_bluetooth_desc', {
						default: 'Disable Bluetooth',
					})}
				</Toggle>
			{/if}
		{/if}
		{#if hasAp}
			{#if hasSecureProvisioning}
				<div class="mb-xs">
					<Toggle id="toggle-disable-wifi-ap" size="m" checked={true} disabled={true}>
						{$format('disable_wifi_ap_desc', {
							default: 'Disable Wi-Fi AP',
						})}
					</Toggle>
					<Text styleType="tiny" class="color-muted ml-xl pl-xs">
						{$format('provision_ap_auto_disable_info', {
							default: 'Wi-Fi AP is automatically disabled after inclusion.',
						})}
					</Text>
				</div>
			{:else}
				<Toggle id="toggle-disable-wifi-ap" size="m" bind:checked={disableAP}>
					{$format('disable_wifi_ap_desc', {
						default: 'Disable Wi-Fi AP',
					})}
				</Toggle>
			{/if}
		{/if}
	</div>
{/if}
